import { useTranslation } from "react-i18next";
import SectionHeading from "../SectionHeading";
//import Button from "../ui/Button";
import { HeadingVariant } from "../../types/constants";
//import { ButtonVariant } from "../../types/constants";

export default function MissionLeftPanel() {
    const { t } = useTranslation();

    return (
        <div className="flex flex-col items-start max-w-[340px] md:max-w-[660px] lap:max-w-[600px] xl:max-w-[600px] lg:max-w-[630px]">
            <div className="lg:max-w-[530px]">
                <SectionHeading text={t("home.headings.mission")} variant={HeadingVariant.LIGHT} />
            </div>
            <p className="mt-6 lg:mt-4 text-text-400 text-base font-normal">{t("home.paragraphs.mission")}</p>

            {/*
            <div className="hidden lap:block mt-[420px]">
                <Button text={t("buttons.learnMore")} variant={ButtonVariant.SECONDARY} />
            </div>
             */}
        </div>
    );
}
